import Booknow from '@/components/custom/ui/clients/tempula/booking/booknow'
import HomestayFooterCmp from '@/components/custom/ui/clients/tempula/homestay/homestayFooter';
import HomestayNavbar from '@/components/custom/ui/clients/tempula/homestay/homestayNavbar';
import bookConfig from '@/constant/config/clients/tempula/book/bookConfig'
import HomestayfooterConfig from '@/constant/config/clients/tempula/homestay/homestayFooterConfig';
import HomenavConfig from '@/constant/config/clients/tempula/homestay/homestayNavConfig';
import { createFileRoute } from '@tanstack/react-router'
import { SEO, buildPageHead } from '@/constant/config/clients/tempula/seo'

export const Route = createFileRoute('/_clients/tempula/book')({
    head: () => buildPageHead(SEO.book),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="bg-BgGallery">
      <div className="fixed top-0 left-0 w-full z-50">
        <HomestayNavbar {...HomenavConfig} />
      </div>     
      <Booknow booking={bookConfig.book} />
      <HomestayFooterCmp {...HomestayfooterConfig} />
    </div>
  );
}